<template>
  <div class="procurementBidding wrapper .ccui-navigation">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>

    <!--内容 start-->
    <div class="ccui-app-container">
      <div class="ccui-app-container-detail-body">
        <div class="newbieGuideTop">
          <div class="newbieGuideTitle">
            {{ $t("page.content.supplierOperationGuide") }}
          </div>
        </div>
        <div class="newbieGuideGroup">
          <ul class="newbieGuideGroupBox" v-if="newbieGuideList.length != 0">
            <li v-for="(item, index) in newbieGuideList" :key="index">
              <dl>
                <dd
                  @mouseover="moveIn(item, index)"
                  @mouseleave="reMove(item, index)"
                  @click="clickImage(item, index)"
                >
                  <img
                    v-if="
                      (index + 1 == 1 && noMove1) ||
                        (index + 1 == 1 && noMove1Click)
                    "
                    :src="item.secondFileUrl"
                    alt=""
                  />
                  <img
                    v-else-if="
                      (index + 1 == 2 && noMove2) ||
                        (index + 1 == 2 && noMove2Click)
                    "
                    :src="item.secondFileUrl"
                    alt=""
                  />
                  <img
                    v-else-if="
                      (index + 1 == 3 && noMove3) ||
                        (index + 1 == 3 && noMove3Click)
                    "
                    :src="item.secondFileUrl"
                    alt=""
                  />
                  <img
                    v-else-if="
                      (index + 1 == 4 && noMove4) ||
                        (index + 1 == 4 && noMove4Click)
                    "
                    :src="item.secondFileUrl"
                    alt=""
                  />
                  <img
                    v-else-if="
                      (index + 1 == 5 && noMove5) ||
                        (index + 1 == 5 && noMove5Click)
                    "
                    :src="item.secondFileUrl"
                    alt=""
                  />
                  <img v-else :src="item.firstFileUrl" alt="" />
                </dd>
                <dt
                  v-if="
                    (index + 1 == 1 && noMove1) ||
                      (index + 1 == 1 && noMove1Click)
                  "
                  class="blueTitle"
                  @mouseover="moveIn(item, index)"
                  @mouseleave="reMove(item, index)"
                  @click="clickImage(item, index)"
                >
                  {{ item.title }}
                </dt>
                <dt
                  v-else-if="
                    (index + 1 == 2 && noMove2) ||
                      (index + 1 == 2 && noMove2Click)
                  "
                  class="blueTitle"
                  @mouseover="moveIn(item, index)"
                  @mouseleave="reMove(item, index)"
                  @click="clickImage(item, index)"
                >
                  {{ item.title }}
                </dt>
                <dt
                  v-else-if="
                    (index + 1 == 3 && noMove3) ||
                      (index + 1 == 3 && noMove3Click)
                  "
                  class="blueTitle"
                  @mouseover="moveIn(item, index)"
                  @mouseleave="reMove(item, index)"
                  @click="clickImage(item, index)"
                >
                  {{ item.title }}
                </dt>
                <dt
                  v-else-if="
                    (index + 1 == 4 && noMove4) ||
                      (index + 1 == 4 && noMove4Click)
                  "
                  class="blueTitle"
                  @mouseover="moveIn(item, index)"
                  @mouseleave="reMove(item, index)"
                  @click="clickImage(item, index)"
                >
                  {{ item.title }}
                </dt>
                <dt
                  v-else-if="
                    (index + 1 == 5 && noMove5) ||
                      (index + 1 == 5 && noMove5Click)
                  "
                  class="blueTitle"
                  @mouseover="moveIn(item, index)"
                  @mouseleave="reMove(item, index)"
                  @click="clickImage(item, index)"
                >
                  {{ item.title }}
                </dt>
                <dt
                  v-else
                  @mouseover="moveIn(item, index)"
                  @mouseleave="reMove(item, index)"
                  @click="clickImage(item, index)"
                >
                  {{ item.title }}
                </dt>
              </dl>
              <span v-if="index + 1 != newbieGuideList.length">
                <img src="@/basa/assets/images/guide-jiantou.png" />
              </span>
            </li>
          </ul>
          <div class="dataNull" v-else>
            <span>{{ $t("page.content.noData") }}</span>
          </div>
        </div>
        <div class="newbieGuideContent" v-html="newbieGuideText"></div>
        <attachmentUpload
          v-if="fileData.length > 0"
          class="newbieGuideContent"
          :type="2"
          :fileData="fileData"
          ref="attachmentUpload"
        ></attachmentUpload>
      </div>
    </div>
    <!--内容 end-->
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import { queryNoviceGuide } from "@/app/shop/api/shopping";
import attachmentUpload from "@/basa/components/common/attachmentUpload";
export default {
  name: "operationManual",
  components: {
    baseBreadCrumb,
    attachmentUpload
  },
  data() {
    return {
      currBreadCrumb: [
        { title: this.$t("page.content.supplierOperationGuide") }
      ],
      newbieGuideList: [],
      newbieGuideText: "",
      noviceGuideId: "",
      title: "",
      noMove1: true,
      noMove2: false,
      noMove3: false,
      noMove4: false,
      noMove5: false,
      noMove1Click: true,
      noMove2Click: false,
      noMove3Click: false,
      noMove4Click: false,
      noMove5Click: false,
      guideNum: "",
      fileData: []
    };
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      queryNoviceGuide({
        appUId: 100069
      }).then(res => {
        if (res.data.code === "0") {
          this.newbieGuideList = res.data.data;
          this.clickImage(this.newbieGuideList[0], 0);
        }
      });
    },
    // 鼠标移入
    moveIn(item, index) {
      if (index + 1 == 1) {
        this.noMove1 = true;
      } else if (index + 1 == 2) {
        this.noMove2 = true;
      } else if (index + 1 == 3) {
        this.noMove3 = true;
      } else if (index + 1 == 4) {
        this.noMove4 = true;
      } else if (index + 1 == 5) {
        this.noMove5 = true;
      }
    },
    // 鼠标移出
    reMove(item, index) {
      if (index + 1 == 1) {
        this.noMove1 = false;
      } else if (index + 1 == 2) {
        this.noMove2 = false;
      } else if (index + 1 == 3) {
        this.noMove3 = false;
      } else if (index + 1 == 4) {
        this.noMove4 = false;
      } else if (index + 1 == 5) {
        this.noMove5 = false;
      }
    },
    // 鼠标点击
    clickImage(item, index) {
      if (index + 1 == 1) {
        this.noMove1 = true;
        this.noMove2 = false;
        this.noMove3 = false;
        this.noMove4 = false;
        this.noMove5 = false;
        this.noMove1Click = true;
        this.noMove2Click = false;
        this.noMove3Click = false;
        this.noMove4Click = false;
        this.noMove5Click = false;
      } else if (index + 1 == 2) {
        this.noMove1 = false;
        this.noMove2 = true;
        this.noMove3 = false;
        this.noMove4 = false;
        this.noMove5 = false;
        this.noMove1Click = false;
        this.noMove2Click = true;
        this.noMove3Click = false;
        this.noMove4Click = false;
        this.noMove5Click = false;
      } else if (index + 1 == 3) {
        this.noMove1 = false;
        this.noMove2 = false;
        this.noMove3 = true;
        this.noMove4 = false;
        this.noMove5 = false;
        this.noMove1Click = false;
        this.noMove2Click = false;
        this.noMove3Click = true;
        this.noMove4Click = false;
        this.noMove5Click = false;
      } else if (index + 1 == 4) {
        this.noMove1 = false;
        this.noMove2 = false;
        this.noMove3 = false;
        this.noMove4 = true;
        this.noMove5 = false;
        this.noMove1Click = false;
        this.noMove2Click = false;
        this.noMove3Click = false;
        this.noMove4Click = true;
        this.noMove5Click = false;
      } else if (index + 1 == 5) {
        this.noMove1 = false;
        this.noMove2 = false;
        this.noMove3 = false;
        this.noMove4 = false;
        this.noMove5 = true;
        this.noMove1Click = false;
        this.noMove2Click = false;
        this.noMove3Click = false;
        this.noMove4Click = false;
        this.noMove5Click = true;
      }
      this.fileData = item.list.map(item => {
        return {
          fileName: item.fileName,
          fileUrl: item.fileUrl,
          fileSumm: item.fileDesc,
          uploadId: item.fileInfoId,
          createTime: item.createTime,
          fileSize: item.fileSize
        };
      });
      this.noviceGuideId = item.noviceGuideId;
      this.title = item.title;
      this.firstFileUrl = item.firstFileUrl;
      this.secondFileUrl = item.secondFileUrl;
      this.firstFileId = item.firstFileId;
      this.secondFileId = item.secondFileId;
      this.newbieGuideText = item.textContent;
      this.guideNum = index;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/config/styles/variables.scss";
// 数据为空时 样式
.dataNull {
  text-align: center;
  color: #909399;
  font-size: 13px;
  margin-top: 60px;
}
/deep/ .ccui-app-wrapper .ccui-main-container .ccui-main-wrapper {
  background-color: #000;
}
.crumbsColor {
  color: #9b9b9b;
  margin-right: 8px;
  float: left;
}
.ccui-app-container-detail {
  min-height: calc(100vh - 220px);
  margin: 15px auto 20px !important;
  padding: 15px 0 15px;
  min-width: 1180px; // 固定宽度 1180px
}
/deep/ .ccui-app-container-detail-body {
  padding: 0px;
}
.newbieGuideTop {
  padding-right: 70px;
  overflow: hidden;
  margin: 0 20px;
}
.newbieGuideTop .newbieGuideTitle {
  font-size: 16px;
  color: #4a4a4a;
  letter-spacing: 0;
  font-weight: 700;
  line-height: 30px;
  float: left;
}
.newbieGuideTop .newbieGuideBtn {
  float: right;
}
.mr10 {
  margin-right: 10px;
}
/deep/.newbieGuideBtn .el-button--primary-icon-big i {
  font-size: 12px;
  vertical-align: 1px;
}
.newbieGuideGroup {
  height: 147px;
  width: 1140px;
  border-bottom: 1px solid #f2f2f2;
  margin: 0 20px;
  overflow: hidden;
}
.newbieGuideContent {
  min-height: 100px;
  margin: 20px 0 0 90px;
  width: 1000px;
}
.newbieGuideContent >>> img {
  max-width: 1000px;
  vertical-align: bottom;
}
.newbieGuideGroupBox {
  margin-left: 90px;
  height: 100%;
  width: 1000px;
}
.newbieGuideGroupBox li {
  display: inline-block;
  height: 100%;
  width: 20%;
  max-width: 280px;
}
.newbieGuideGroupBox li dl {
  width: calc(100% - 21px);
  margin-top: 37px;
  float: left;
  text-align: center;
}
.newbieGuideGroupBox li > span {
  float: right;
  margin-top: 54px;
}
.newbieGuideGroupBox li dl dd {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: 0 auto;
  cursor: pointer;
}
.newbieGuideGroupBox li dl dd img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.newbieGuideGroupBox li dl dt {
  font-size: 14px;
  cursor: pointer;
  display: inline-block;
  margin-top: 10px;
}
.blueTitle {
  color: #0089ef;
}
</style>
